import React from 'react';
import ReactSwitch from 'react-switch';

import { TThemeColorsKey } from 'shared/design-system/theme/colors/TThemeColors';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { SwitchStyled, StatusText, LabelText } from './Switch.styles';

type SwitchProps = {
  onColor?: TThemeColorsKey;
  offColor?: TThemeColorsKey;
  onHandlecolor?: TThemeColorsKey;
  offHandleColor?: TThemeColorsKey;

  checked: boolean;
  label: string;
  onSwitch: () => void;
  statusLabel?: boolean;
  width?: number;
  height?: number;
};

/**
 * @param {string} [color] - background color of indicator (defaults to green20)
 * @param {string} [text] - text displayed
 * @deprecated use Beacon's Toggle
 */

export function Switch({
  checked,
  label,
  onSwitch,
  statusLabel,
  onColor,
  onHandlecolor,
  offColor,
  offHandleColor,
  width = 36,
  height = 20,
}: SwitchProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <SwitchStyled>
      <LabelText as="p">{label}</LabelText>
      <ReactSwitch
        checked={checked}
        onChange={onSwitch}
        onColor={onColor || theme.colors.buttonButtonBkgAltSecondary2100}
        onHandleColor={onHandlecolor || theme.colors.iconIconPrimaryPressedSecondary2100}
        offColor={offColor || theme.colors.componentStrongEmphasisGrey}
        offHandleColor={offHandleColor || theme.colors.textInverseWhite}
        checkedIcon={false}
        uncheckedIcon={false}
        width={width}
        height={height}
      />
      {statusLabel && <StatusText as="p">{checked ? t('switch.on') : t('switch.off')}</StatusText>}
    </SwitchStyled>
  );
}

export default Switch;
